import React from "react";
import { default as WTypography } from "@mui/material/Typography";

function Typography(props) {
  return <WTypography {...props} />;
}

export default Typography;
